import { render, staticRenderFns } from "./changelog-co-applicants.vue?vue&type=template&id=7254ce89"
import script from "./changelog-co-applicants.vue?vue&type=script&lang=js"
export * from "./changelog-co-applicants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports